import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const ProductsServicesTable = () => {
  return (
    <LmsTable
      actionButtons={["add", "remove", "export", "activate", "deactivate"] as any}
      apiSuffix="/vendors/list-offering"
      deleteSuffix="/vendors/vendor-offering"
      activateSuffix="/vendors/activate-offering"
      deActivateSuffix="/vendors/deactivate-offering"
      skipClick
      columnLabelsDictionary={{
        offering: "Product/Service",
      }}
    />
  );
};

const addVendorOfferingFormFields = ( myForm ) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Vendor", "/vendors/list-organizations", {
      name: "vendorOrganizationId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Product/Service", "/vendors/list-offerings", {
      dropdownMultiple: true,
      name: "offeringIds",
      dependencyField: "vendorOrganizationId",
      dependencyFieldQuery: "vendorOrganizationId",
      dropdownSkipCache: true
    }),
  ]);

  return myForm;
};

const AddVendorOfferingForm = () => {
  const myForm = addVendorOfferingFormFields(
    new BCFormController({}, { submitSuffix: "/vendors/create-offering" })
  );
  const formActions = ["save-new", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const LmsVendorsProductsServices = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <ProductsServicesTable />}
      {isAdd && <AddVendorOfferingForm />}
    </>
  );
};

export default LmsVendorsProductsServices;